var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8496_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7935 26.4102H17.8071",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7061 22.3234C14.7901 21.2397 16.2603 20.6309 17.7932 20.6309C19.3261 20.6309 20.7962 21.2397 21.8803 22.3234",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61768 18.2343C10.6913 17.1606 11.9659 16.3089 13.3687 15.7278C14.7715 15.1467 16.275 14.8477 17.7934 14.8477C19.3118 14.8477 20.8153 15.1467 22.2181 15.7278C23.6208 16.3089 24.8954 17.1606 25.9691 18.2343",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53027 14.1468C12.3026 7.37295 23.2835 7.37295 30.0993 14.1468",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8496_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6856,
    height: 34.6856,
    fill: "white",
    transform: "translate(0.450195 0.395508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.24559dbfe5f619f7ed16da4da8a60d04.svg";
export { ForwardRef as ReactComponent };